import { createVuetify } from 'vuetify'
import { uk } from 'vuetify/locale'
import defaults from './defaults'
import { icons } from './icons'
import theme from './theme'

// Styles
import '@core/scss/template/libs/vuetify/index.scss'
import 'vuetify/styles'

const ukOverride = {
  ...uk,
  dateRangeInput: {
    divider: 'до',
  },
  datePicker: {
    itemsSelected: '{0} вибрано',
    range: {
      title: 'Оберіть дати',
      header: 'Введіть дати',
    },
    title: 'Оберіть дату',
    header: 'Введіть дату',
    input: {
      placeholder: 'Введіть дату',
    },
  },
}

export default createVuetify({
  defaults,
  icons,
  theme,
  locale: {
    locale: 'uk',
    messages: { uk: ukOverride },
  },
})
